import { gql } from '@apollo/client';

export const GET_AI_RESPONSE = gql`
  query GetAiResponse($prompt: AiPromptType!, $args: JSON) {
    getAiResponse(prompt: $prompt, args: $args)
  }
`;
